"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 70 80';

var Notes = function Notes() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    fill: "none",
    d: "M41.41,48.82,24.56,55.89l3.23-17.53a3.4,3.4,0,0,1,.62-1.43L40,21.54H11.5A6.51,6.51,0,0,0,5,28V64a6.51,6.51,0,0,0,6.5,6.5h36A6.51,6.51,0,0,0,54,64V32.87L42.81,47.73A3.34,3.34,0,0,1,41.41,48.82Z"
  }), _react["default"].createElement("polygon", {
    fill: "none",
    points: "31.15 47.7 39.08 44.38 58.22 18.96 51.83 14.14 32.64 39.63 31.15 47.7"
  }), _react["default"].createElement("path", {
    fill: "none",
    d: "M59.93,5.22a1.09,1.09,0,0,0-1.54.22l-3.55,4.71L61.23,15l3.55-4.71a1.1,1.1,0,0,0-.22-1.54Z"
  }), _react["default"].createElement("path", {
    d: "M67.57,4.71,62.94,1.22a6.12,6.12,0,0,0-8.55,1.21L43.77,16.54H11.5A11.51,11.51,0,0,0,0,28V64a11.51,11.51,0,0,0,11.5,11.5h36A11.51,11.51,0,0,0,59,64V28a11,11,0,0,0-.13-1.63l9.9-13.15A6.11,6.11,0,0,0,67.57,4.71ZM51.83,14.14,58.22,19,39.08,44.38,31.15,47.7l1.49-8.07ZM54,64a6.51,6.51,0,0,1-6.5,6.5h-36A6.51,6.51,0,0,1,5,64V28a6.51,6.51,0,0,1,6.5-6.5H40L28.41,36.93a3.4,3.4,0,0,0-.62,1.43L24.56,55.89l16.85-7.07a3.34,3.34,0,0,0,1.4-1.09L54,32.87ZM64.78,10.25,61.23,15l-6.39-4.81,3.55-4.71a1.09,1.09,0,0,1,1.54-.22l4.63,3.49A1.1,1.1,0,0,1,64.78,10.25Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Notes, {
  viewBox: viewBox
});

exports["default"] = _default;